// Team members who can sign in to the control panel. Admin-only endpoints.
import { api } from "./client";

export const USER_ROLES = [
  { value: "admin", label: "Admin", hint: "Everything, including managing the team." },
  { value: "member", label: "Member", hint: "Enquiries, clients, orders, company details and SEO." },
];

export const emptyUser = {
  name: "",
  email: "",
  role: "member",
  password: "",
};

export async function getUsers() {
  const { users } = await api.get("/users", { auth: true });
  return users;
}

export async function createUser(data) {
  const { id } = await api.post(
    "/users",
    {
      name: String(data.name || "").trim(),
      email: String(data.email || "").trim(),
      role: data.role || "member",
      password: data.password || "",
    },
    { auth: true }
  );
  return id;
}

// Password is only sent when a new one was typed.
export async function updateUser(id, data) {
  const payload = {};
  if ("name" in data) payload.name = String(data.name || "").trim();
  if ("email" in data) payload.email = String(data.email || "").trim();
  if ("role" in data) payload.role = data.role;
  if ("active" in data) payload.active = Boolean(data.active);
  if (data.password) payload.password = data.password;
  await api.put(`/users/${id}`, payload, { auth: true });
}

export async function deleteUser(id) {
  await api.del(`/users/${id}`, { auth: true });
}
